export const canAccessProtectedApis = (
  userManagementResolved: boolean,
  userManagementEnabled: boolean,
  accessToken?: string | null
): boolean => {
  if (!userManagementResolved) {
    return false;
  }

  if (!userManagementEnabled) {
    return true;
  }

  return typeof accessToken === "string" && accessToken.trim().length > 0;
};
